import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tab', 'panel'];
  static values = { active: String };

  connect() {
    if (!this.activeValue) {
      const selected = this.tabTargets.find((tab) => tab.getAttribute('aria-selected') === 'true');
      this.activeValue = (selected ?? this.tabTargets[0])?.dataset.tabName;
    }
    this._update();
  }

  select(event) {
    this.activeValue = event.currentTarget.dataset.tabName;
    this._update();
  }

  navigate(event) {
    const tabs = this.tabTargets;
    const index = tabs.indexOf(event.currentTarget);
    const targetIndex = {
      ArrowRight: (index + 1) % tabs.length,
      ArrowLeft: (index - 1 + tabs.length) % tabs.length,
      Home: 0,
      End: tabs.length - 1,
    }[event.key];
    if (targetIndex === undefined) return;

    event.preventDefault();
    this.activeValue = tabs[targetIndex].dataset.tabName;
    this._update();
    tabs[targetIndex].focus();
  }

  _update() {
    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.tabName === this.activeValue;
      tab.classList.toggle('border-indigo-600', active);
      tab.classList.toggle('text-indigo-600', active);
      tab.classList.toggle('border-transparent', !active);
      tab.classList.toggle('text-gray-500', !active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
    });
    this.panelTargets.forEach((panel) => {
      panel.classList.toggle('hidden', panel.dataset.tabName !== this.activeValue);
    });
  }
}
